module.exports = __webpack_public_path__ + "img/3-2.d5e7bdb0.png";